export type RuleSet = {
  allow: string[];
  deny: string[];
};

function toRegex(pattern: string): RegExp {
  // Escape regex chars, then convert * to [^:]* for each segment
  const esc = pattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&');
  const rx = '^' + esc.replace(/\*/g, '[^:]*') + '$';
  return new RegExp(rx);
}

export function compile(rules: RuleSet) {
  const deny = rules.deny.map((p) => toRegex(p));
  const allow = rules.allow.map((p) => toRegex(p));

  return (principal: { orgId: string }) => (resource: string, action: string) => {
    const full = `org:${principal.orgId}::${resource}::${action}`;

    // Check deny rules first (they take precedence)
    if (deny.some((r) => r.test(full))) return false;

    // Check allow rules
    if (allow.some((r) => r.test(full))) return true;

    // Try action wildcard
    const wildcard = `org:${principal.orgId}::${resource}::*`;
    if (deny.some((r) => r.test(wildcard))) return false;
    if (allow.some((r) => r.test(wildcard))) return true;

    // Default deny
    return false;
  };
}
